import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'pf-content-header',
    templateUrl: './content-header.component.html',
    styleUrls: ['./content-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ContentHeaderComponent {}
